import config from "../config";
import {httpGet} from "./http-functions";
import {
    Domains,
    MachineCapability,
    MembershipCapabilitiesResponse,
    MembershipCapability,
    ProGuestCapability,
    UserCapability
} from "../models/capabilities";


export const fetchMachineCapability = async (organizationId: number): Promise<MachineCapability> => {
    const url = `${config.api}/Machines/does-user-have-machine-capabilities?organizationId=${organizationId}`;
    const resp = await httpGet(url);
    return resp.data.data.doesUserHaveMachineCapabilities;
}

export const fetchProGuestCapability = async (organizationId: number): Promise<ProGuestCapability> => {
    const url = `${config.api}/providers/organizations/${organizationId}/capabilities`;
    const resp = await httpGet(url);
    return resp.data;
}

export const fetchMembershipCapability = async (organizationId: number): Promise<MembershipCapability> => {
    const url = `${config.api}/organizations/${organizationId}/capabilities`;
    const resp = await httpGet(url);
    const capabilities: MembershipCapabilitiesResponse = resp.data;
    return capabilities.userCapabilities.reduce((acc: any, cur: any) => {
        const id = cur.id;
        return {...acc, [id]: cur}
    }, {});
}

export const fetchUserCapabilities = async (organizationId: number): Promise<{[organizationId: number]: UserCapability}> => {
    const capabilities: UserCapability = {
        [Domains.Membership]: await fetchMembershipCapability(organizationId),
        [Domains.ProGuest]: await fetchProGuestCapability(organizationId),
        [Domains.Machines]: await fetchMachineCapability(organizationId)
    }
    return {[organizationId]: capabilities};
};
